import React, { useEffect, useState } from "react";
import UserSection from "../../Services/User/UserLogin";
import ExcelJS from "exceljs";
import animationData from "../../animations/loader_animation0.json";
import Lottie from "lottie-react";
import Loader from "../utils/Loader";
import { handleApiError } from "../../Helpers/handleApiError ";
import Swal from "sweetalert2";
import QR from "../../../src/clientlogo/qr_code2.png";
import Apiurl from "../../Helpers/apiUrl";
import axios from "axios";
import { getCurrencySymbol, formatAmount } from "../../Helpers/currencyHelper";

const DownloadSummary = ({ project, sendData }) => {
  const myStyles = {
    // display: 'flex',
    // justifyContent: 'center',
    // border:'1px solid #D3D3D3',
    // borderBottom: '1px solid #D3D3D3',
  };
  const [projectId, setprojectId] = useState(project);
  const [projectData, setprojectData] = useState();
  const [projectSection, setSection] = useState([]);
  const [sectionArr, setSectionArr] = useState([]);
  const [sectionTotal, setSectionTotal] = useState(0);
  const [sectionId, setSectiionId] = useState(0);
  const [loading, setLoading] = useState(false);
  const [button, setButton] = useState("Download Excel");
  const [disable, setDisable] = useState(false);

  useEffect(() => {
    if (project) {
      viewprojectById();
    }
  }, [project]);

  const formatNumber = (value) => {
    let val = value ? value : 0;

    if (typeof val === "string") {
      val = val.replace(/,/g, "");
    }

    val = parseFloat(val);

    return val.toFixed(1);
  };

  const formatNoDecimal = (value) => {
    let val = value ? value : 0;
    if (typeof val === "string") {
      val = val.replace(/,/g, "");
    }

    val = parseFloat(val);

    val = Math.round(val);

    return val;
  };


  const formatPerc = (value) => {
    if (typeof value === "number") {
      return value.toString() + "%";
    } else {
      throw new Error("Input value must be a number");
    }
  };

  let sectionCount = 0;
  const viewprojectById = async () => {
    try {
      setLoading(true);
      let res = await UserSection.downloadExcelById(project);
      if (res.status) {
        setLoading(false);
        const sectionsArray = Object.entries(res.data.section);
        setSectionArr(sectionsArray);
        setprojectData(res.data);
        sectionCount = Object.keys(res.data.section).length;
        setSectionTotal(sectionCount);

        try {
          const token = localStorage.getItem("u_token");

          axios.post(
            `${Apiurl}project/download-status/${project}`,
            { excelCount: 1 },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
        } catch (statusError) {
          console.error("Failed to update download status", statusError);
        }
        await downloadExcelFile();
      } else {
        return 0;
      }
    } catch (error) {
      console.log(error);
      sendData("failed");
      Swal.fire({
        icon: "error",
        title: "Something went wrong",
        text: "Try again  later",
      });
    }
  };
  // Helper function to convert a blob to base64
  const blobToBase64 = async (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = function () {
        resolve(reader.result.split(",")[1]);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const downloadExcelFile = async () => {
    const workbook = new ExcelJS.Workbook();

    // Add summary worksheet
    const summarySheet = workbook.addWorksheet("Summary");

    // Add new headings and logos
    const borderStyle = {
      top: {
        style: "medium",
      },
      left: {
        style: "medium",
      },
      bottom: {
        style: "medium",
      },
      right: {
        style: "medium",
      },
    };

    const newHeadings = [
      ["GROHE INDIA PVT. LTD."],
      ["LIXIL CORPORATION"],
      ["Quotation Letter"],
    ];

    let currentRow = 1;
    const newHeadingsFontSize = 18;
    const newHeadingsHeight = 60;

    // Fetch the logos for the new headings
    return Promise.all([
      fetch("/lixil.png").then((res) => res.blob()),
      fetch("/grohe.png").then((res) => res.blob()),
      fetch("/american.png").then((res) => res.blob()),
    ]).then(async ([blob1, blob2, blob3]) => {
      const image1 = await workbook.addImage({
        base64: await blobToBase64(blob1),
        extension: "png",
      });
      const image2 = await workbook.addImage({
        base64: await blobToBase64(blob2),
        extension: "png",
      });
      const image3 = await workbook.addImage({
        base64: await blobToBase64(blob3),
        extension: "png",
      });

      newHeadings.forEach((heading) => {
        const row = summarySheet.addRow(heading);

        if (heading[0] === "Quotation Letter") {
          row.height = 25; // Reduced height
        } else {
          row.height = newHeadingsHeight;
        }

        row.getCell(1).font = {
          bold: true,
          size: newHeadingsFontSize,
        };
        row.getCell(1).alignment = {
          wrapText: true,
          horizontal: "center",
          vertical: "middle",
        };
        row.getCell(1).border = borderStyle;
        summarySheet.mergeCells(`A${currentRow}:O${currentRow}`);
        currentRow++;
      });

      // Add the logos next to the "GROHE INDIA PVT. LTD." heading
      summarySheet.addImage(image1, {
        tl: {
          col: 0.2,
          row: 0.3,
        },
        ext: {
          width: 110,
          height: 53,
        },
      });

      summarySheet.addImage(image2, {
        tl: {
          col: 12,
          row: 0.3,
        },
        ext: {
          width: 90,
          height: 53,
        },
      });
      summarySheet.addImage(image3, {
        tl: {
          col: 13.4,
          row: 0.3,
        },
        ext: {
          width: 90,
          height: 53,
        },
      });

      // Merge and add border style for client details
      const mergeAndAddBorder = (label, value, colStart, colEnd) => {
        const cell = summarySheet.getCell(`A${currentRow}`);
        cell.value = label + ": " + value;
        cell.border = borderStyle;
        summarySheet.mergeCells(
          `A${currentRow}:${String.fromCharCode(68 + colEnd)}${currentRow}`
        );
        currentRow++;
      };
      var c_id = document.getElementById("c_id").textContent;
      var namec = document.getElementById("namec").textContent;
      var c_afd = document.getElementById("c_afd").textContent;
      var c_add_to = document.getElementById("c_add_to").textContent;
      var c_project_id = document.getElementById("c_project_id").textContent;
      var c_date = document.getElementById("c_date").textContent;
      var c_site = document.getElementById("c_site").textContent;
      var c_email = document.getElementById("c_email").textContent;
      var c_phone = document.getElementById("c_phone").textContent;
      var valid_date = document.getElementById("valid_date").textContent;

      var client_id = c_id;
      var namec = namec;
      var site = c_site;
      var architect = c_afd;
      var address = c_add_to;
      var project_id = c_project_id;
      var date = c_date;
      var email = c_email;
      var phone = c_phone;
      // mergeAndAddBorder("Client ID", client_id, 1, 11);
      mergeAndAddBorder("Client Name", namec, 1, 11);
      mergeAndAddBorder("Billing Address", site, 1, 11);
      mergeAndAddBorder("Architect Firm Detail", architect, 1, 11);
      mergeAndAddBorder("Email", email, 1, 11);
      mergeAndAddBorder("Phone", phone, 1, 11);
      mergeAndAddBorder("Site Address", address, 1, 11);
      mergeAndAddBorder("Project ID", project_id, 1, 11);
      mergeAndAddBorder("Date", date, 1, 11);
      /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      // Add a blank row
      const blankRow = summarySheet.addRow([]);
      blankRow.height = 20;

      const overallSummaryHeadingArray = [
        "Particulars",
        "List Price",
        "Offer Price",
        "Shower - Offer Price",
        "Basin - Offer Price",
        "EWC - Offer Price",
        "Kitchen - Offer Price",
        "Faucet - Offer Price",
        "Quantity",
        "Discount Percent %",
      ];
      // Add row header for Particulars, MRP, and Discounted Price
      const rowHeader = summarySheet.addRow(overallSummaryHeadingArray);

      overallSummaryHeadingArray.forEach((ele, index) => {
        summarySheet.getColumn(index + 1).width = 30;
      });

      rowHeader.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: {
            argb: "FF112038",
          },
        };
        cell.font = {
          color: {
            argb: "FFFFFFFF",
          },
          bold: true,
        };
        // cell.border = borderStyle;
        // Center align both horizontally and vertically
        cell.alignment = {
          horizontal: "center",
          vertical: "middle",
        };
      });

      //Common Heading for all the sections

      const currencySymbol = getCurrencySymbol();
      const sectionHeading = [
        "S.No.",
        "Product Code",
        "Area",
        "Brand",
        "Product Description",
        "Finish",
        "Collection",
        "Product Type",
        "HSN Code",
        "Category",
        "Price Segment",
        "Preferences",
        "Product Image",
        "Line Diagram",
        "Quantity",
        `MRP (${currencySymbol})`,
        `Base Price (${currencySymbol})`,
        "Discount %",
        `Discount Price (${currencySymbol})`,
        `Offer Price / Unit (${currencySymbol})`,
        "GST/VAT %",
        `Total Discount (${currencySymbol})`,
        `Total (${currencySymbol})`,
      ];
      const columnWidths = [
        6, 13, 7, 8, 29, 13, 20, 15, 15, 15, 15, 15, 15, 15, 9, 9, 12, 11, 16, 16, 12, 16, 10,
      ];
      const sectionNamesArray = [];

      const Table = document
        .getElementById("productTable")
        .getElementsByTagName("tbody")[0];
      const Rows = Table.rows;
      const Promises = [];

      for (let i = 0; i < Rows.length; i++) {
        const row = Rows[i];
        const cellText = row.cells[0].textContent;
        const rowClassName = row.className;

        //If Table Row has section-heading as a classname that means its a heading;
        if (rowClassName == "section-heading") {
          const individualOverallSummary = [];
          let sectionRowIndex = 1;
          // const sectionName = sectionNamesArray.includes(cellText.trim())
          // const sectionName = sectionNamesArray.includes(cellText.trim()?.toLowerCase())
          //   ? cellText.trim() + "_1"
          //   : cellText.trim();
          // sectionNamesArray.push(sectionName?.toLowerCase());

          // //Section Heading Name to maekt the WorksheetName..
          // const selectionWorksheet = workbook.addWorksheet(sectionName);

          //  for manging same selection names  start
          let baseName = cellText.trim();
          let sectionName = baseName;
          let counter = 1;

          while (sectionNamesArray.includes(sectionName.toLowerCase())) {
            sectionName = `${baseName}_${counter}`;
            counter++;
          }
          sectionNamesArray.push(sectionName.toLowerCase());
          //end

          const selectionWorksheet = workbook.addWorksheet(sectionName);

          const blankRow = selectionWorksheet.addRow([]);

          // Merge the first row cells to create a single header
          const totalColumns = sectionHeading.length; // Total number of columns in the table header
          const firstCell = selectionWorksheet.getCell(blankRow.number, 1);
          const lastCell = selectionWorksheet.getCell(
            blankRow.number,
            totalColumns
          );

          // Merge cells for the blank row
          selectionWorksheet.mergeCells(
            blankRow.number,
            1,
            blankRow.number,
            totalColumns
          );

          // Style the merged cell (optional)
          firstCell.value = sectionName; // Add custom text if needed
          firstCell.alignment = { horizontal: "center", vertical: "middle" };
          firstCell.font = {
            bold: true,
            size: 14,
            color: { argb: "FF000000" },
          };
          firstCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFD9D9D9" },
          };
          firstCell.border = borderStyle;

          //Manage the Heading Height for the section.
          managerHeadingHeight(selectionWorksheet, sectionHeading, borderStyle);

          individualOverallSummary.push(sectionName);

          for (let j = 1; ; j++) {
            const sectionBody = Rows[i++ + 1];

            if (sectionBody == undefined) {
              i = Rows.length;
              break;
            }
            if (sectionBody?.className == "section-heading") {
              i = i - 1;
              break;
            }

            // const rowData = Array.from(sectionBody.cells, (cell) => {
            //   const img = cell.querySelector("img");
            //   if (img) {
            //     const promise = new Promise((resolve, reject) => {
            //       let base64 = img.src;
            //       // const promise = fetch(img.src)
            //       //     .then(res => res.blob())
            //       //     .then(blobToBase64)
            //       //     .then(base64 => {

            //       setTimeout(function () {
            //         resolve(
            //           addImgToExcel(
            //             base64,
            //             sectionRowIndex++,
            //             selectionWorksheet,
            //             workbook
            //           )
            //         );
            //       }, 200);
            //     });
            //     // });
            //     Promises.push(promise);
            //     return null;
            //   } else {
            //     return cell.textContent;
            //   }
            // });

            let currentProductRowIndex = sectionRowIndex;

            const rowData = Array.from(sectionBody.cells, (cell, colIdx) => {
              const img = cell.querySelector("img");
              if (img) {
                // colIdx 11 = Product Image (Col 12), colIdx 12 = Line Diagram (Col 13)
                const targetCol = colIdx === 13 ? 14 : 13;

                const promise = new Promise((resolve, reject) => {
                  let base64 = img.src;

                  setTimeout(function () {
                    resolve(
                      addImgToExcel(
                        base64,
                        currentProductRowIndex,
                        selectionWorksheet,
                        workbook,
                        targetCol
                      )
                    );
                  }, 200);
                });

                Promises.push(promise);
                return null;
              } else {
                return cell.textContent;
              }
            });

            let excelRow = selectionWorksheet.addRow(rowData);
            excelRow.height = 80;

            // Increment sectionRowIndex once per product row (matching original logic)
            sectionRowIndex++;

            const cellText = sectionBody.cells[0].textContent;

            if (
              cellText.toLowerCase().includes("list price") ||
              cellText.toLowerCase().includes("offer price") ||
              cellText.toLowerCase().includes("basin area subtotal") ||
              cellText.toLowerCase().includes("ewc area subtotal") ||
              cellText.toLowerCase().includes("kitchen area subtotal") ||
              cellText.toLowerCase().includes("faucets area subtotal") ||
              cellText.toLowerCase().includes("shower area subtotal") ||
              cellText.toLowerCase().includes("total quantity")
            ) {
              excelRow.height = 20;
              selectionWorksheet.mergeCells(
                `A${excelRow.number}:W${excelRow.number}`
              );

              if (cellText.toLowerCase().includes("list price"))
                individualOverallSummary.push(managerOverallSummary(cellText));
              else if (cellText.toLowerCase().includes("offer price"))
                individualOverallSummary.push(managerOverallSummary(cellText));
              else if (cellText.toLowerCase().includes("basin area subtotal"))
                individualOverallSummary.push(managerOverallSummary(cellText));
              else if (cellText.toLowerCase().includes("ewc area subtotal"))
                individualOverallSummary.push(managerOverallSummary(cellText));
              else if (cellText.toLowerCase().includes("kitchen area subtotal"))
                individualOverallSummary.push(managerOverallSummary(cellText));
              else if (cellText.toLowerCase().includes("faucets area subtotal"))
                individualOverallSummary.push(managerOverallSummary(cellText));
              else if (cellText.toLowerCase().includes("shower area subtotal"))
                individualOverallSummary.push(managerOverallSummary(cellText));
              else if (cellText.toLowerCase().includes("total quantity"))
                individualOverallSummary.push(managerOverallSummary(cellText));
            }
            for (let columnIndex = 1; columnIndex <= 23; columnIndex++) {
              const cellText = sectionBody.cells[0].textContent;

              if (
                cellText.toLowerCase().includes("list price") ||
                cellText.toLowerCase().includes("offer price") ||
                cellText.toLowerCase().includes("basin area subtotal") ||
                cellText.toLowerCase().includes("ewc area subtotal") ||
                cellText.toLowerCase().includes("kitchen area subtotal") ||
                cellText.toLowerCase().includes("faucets area subtotal") ||
                cellText.toLowerCase().includes("shower area subtotal") ||
                cellText.toLowerCase().includes("total quantity")
              ) {
                const cell = excelRow.getCell(columnIndex);
                cell.border = borderStyle;
                cell.alignment = {
                  horizontal: "right",
                  vertical: "middle",
                };
              } else {
                const cell = excelRow.getCell(columnIndex);
                cell.border = borderStyle;
                cell.alignment = {
                  horizontal: "center",
                  vertical: "middle",
                };
              }
            }
          }

          //Function to Section Summary manage to align Right and height 20px;
          managerIndividualSectionSummary(selectionWorksheet);

          columnWidths.forEach((width, i) => {
            selectionWorksheet.getColumn(i + 1).width = width;
          });
          let total_mrp = individualOverallSummary[1]; // List Price
          let total_discounts = individualOverallSummary[2]; // Total discount
          let total_discount = parseFloat(total_discounts) * parseFloat(100);
          // Ensure total_mrp and total_discount are numbers
          total_mrp = parseFloat(total_mrp);
          total_discount = parseFloat(total_discount);

          // Calculate the discount percentage
          let total_range_per =
            parseFloat(total_discount) / parseFloat(total_mrp);
          total_range_per = formatNumber(total_range_per);
          total_range_per = total_range_per ? total_range_per : 0;
          individualOverallSummary[1] = formatNumber(total_mrp);
          individualOverallSummary[2] = formatNumber(total_discounts);
          // individualOverallSummary[3] = String(total_range_per) + "%";
          individualOverallSummary[3] = individualOverallSummary[3];
          individualOverallSummary[4] = individualOverallSummary[4];
          individualOverallSummary[5] = individualOverallSummary[5];
          individualOverallSummary[6] = individualOverallSummary[6];
          individualOverallSummary[7] = individualOverallSummary[7];
          individualOverallSummary[8] = individualOverallSummary[8];
          individualOverallSummary[9] =
            "                                                " +
            total_range_per +
            "%";
          summarySheet.addRow(individualOverallSummary);
          const blueRow = summarySheet.getRow(summarySheet.rowCount);
          blueRow.eachCell((cell) => {
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FFADD8E6" },
            };
            cell.font = {
              bold: true,
            };
            cell.border = borderStyle;
          });
          // const row = summarySheet.addRow(individualOverallSummary);

          // row.getCell(4).alignment = { horizontal: "right" };
          // row.getCell(5).alignment = { horizontal: "right" };
          // row.getCell(6).alignment = { horizontal: "right" };
          // row.getCell(7).alignment = { horizontal: "right" };
          // row.getCell(8).alignment = { horizontal: "right" };
          // row.getCell(9).alignment = { horizontal: "right" };
          // row.getCell(10).alignment = { horizontal: "right" };
        }
      }

      let skipRow = 14 + (sectionCount + 1);

      summarySheet.addRow([""]);
      summarySheet.addRow([""]);
      summarySheet.addRow([""]);
      summarySheet.addRow([""]);

      summarySheet.mergeCells(`A${skipRow}:O${skipRow}`);
      const mergedCell = summarySheet.getCell(`A${skipRow}`);
      // mergedCell.value = 'Terms and Conditions:\n1. This is an example.\n2. Adjust the terms as needed.\n3. Adjust the terms as needed.\n4. Adjust the terms as needed.\n5. Adjust the terms as needed.';
      mergedCell.value = "Terms and Conditions";

      summarySheet.getRow(skipRow).height = 20;
      // Set wrapText to tru5
      mergedCell.alignment = { wrapText: true };

      mergedCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: {
          argb: "FF112038",
        },
      };
      mergedCell.font = {
        color: {
          argb: "FFFFFFFF",
        },
        bold: true,
      };
      mergedCell.border = borderStyle;
      // Center align both horizontally and vertically
      mergedCell.alignment = {
        horizontal: "center",
        vertical: "middle",
      };
      skipRow = skipRow + 1;
      summarySheet.mergeCells(`A${skipRow}:O${skipRow}`);
      const mergedCell1 = summarySheet.getCell(`A${skipRow}`);
      mergedCell1.value = `1. This quote is being made on behalf of the channel partner/ company as per agreement. \n2. This quote shall be valid for 60 days from the date of the document mentioned above or until the date revision or amendment or modification of the quote, whichever is earlier. \n3. Please send your written confirmation towards acceptance of quote/offer within the validity period to the channel partner. \n4. In case of cancellation of sale after acceptance of offer, customer shall be liable to pay cancellation fee as per below : \n           . 15 days prior to the date of delivery  cancellation panelty will be the % of total order value. \n           . 30 days prior to the date of delivery cancellation panelty will be the  % of total order value. \n           . 45 days prior to the date of delivery  cancellation panelty will be the % of total order value. \n5. The quote can be revised, amended or modified or withdrawn at any time. \n6. Delivery of material shall be subject to availability of stock with the channel partner/company and the terms mutually agreed. \n7.  Rates are delivered at site . \n8. Unloading of the goods to be done by the client and not by the supplier. \n9. The Goods once received needs to be checked and any deviation should be informed within 24hours of delivery . \n10. Local levies / GST etc., are as per prevailing rates any change in the same will be applicable at the time of billing and supplies . \n11. Payment terms 100% advance / Local Letter of Credit / Bank Guarantee .\n12. Goods once sold will not be taken return , replacement will be applicable as per terms.\n13. The products are subject to company’s warranty policy as detailed on Company’s website for India. \n14. The products quoted can go under product lifecycle change and the latest/replacement product against the same will be supplied. \n15. All disputes arising in relation to this quote shall be subject to the jurisdiction of courts in New Delhi. \n16. Add the Customer care numbers ( …………). \n17. Signed …………………………… name of the manager quoting ( this can be auto populated )\nQuotation is valid for till Date - ${valid_date ? new Date(valid_date).toLocaleDateString("en-GB") : "N/A"
        }  \n Phone No : \n Office Board line No \n  \n Thanking you \n LIXIL INDIA PVT LTD (A LIXIL Corporation Company) \n 10th floor, Baani Address One, \n Near Double Tree by Hilton, Golf Course Road, \n Sector - 56, Gurugram, Haryana - 122011 \n grohe.co.in \n americanstandard.in \n Customer Care No. 18001024475  `;

      summarySheet.getRow(skipRow).height = 500;
      mergedCell1.alignment = { wrapText: true };
      mergedCell1.border = borderStyle;

      // Fetch the QR code image
      const qrCodeBlob = await fetch(QR).then((res) => res.blob());
      const qrCodeImage = await workbook.addImage({
        base64: await blobToBase64(qrCodeBlob),
        extension: "png",
      });

      summarySheet.addImage(qrCodeImage, {
        tl: { col: 7, row: skipRow - 0.7 },
        ext: { width: 550, height: 300 },
        editAs: "absolute",
      });

      summarySheet.addRow([""]);
      summarySheet.mergeCells(`A${skipRow + 1}:O${skipRow + 1}`);
      const blueCell = summarySheet.getCell(`A${skipRow + 1}`);
      blueCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF112038" },
      };

      // Wait for all images to be added and then trigger the download
      Promise.all(Promises).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `${project}.xlsx`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          sendData("downloaded");
        });
      });
    });
  };


  function addImgToExcel(
    base64,
    sectionRowIndex,
    selectionWorksheet,
    workbook,
    colIndex = 12
  ) {
    if (!base64) {
      return;
    }

    const image = workbook.addImage({
      base64,
      extension: "png",
    });

    const targetCol = colIndex - 1; // 0-indexed column
    const targetRow = sectionRowIndex + 1; // 0-indexed row

    selectionWorksheet.addImage(image, {
      tl: {
        col: targetCol,
        row: targetRow,
        nativeColOff: 76200, // Exact 8px top-left margin (8 * 9525 EMUs)
        nativeRowOff: 76200,
      },
      br: {
        col: targetCol + 1,
        row: targetRow + 1,
        nativeColOff: -76200, // Exact 8px bottom-right margin (-8 * 9525 EMUs)
        nativeRowOff: -76200,
      },
      editAs: "oneCell",
    });
  }

  function managerOverallSummary(value) {
    const amount = value.split(":")[1];
    return Number(amount);
  }

  //Function to manger the each Section Summary Alignment.
  function managerIndividualSectionSummary(selectionWorksheet) {
    for (let i = 0; i < 5; i++) {
      const sectionSummaryElement = selectionWorksheet.getRow(
        selectionWorksheet.rowCount - i
      );
      sectionSummaryElement.getCell(1).alignment = {
        horizontal: "right",
        vertical: "middle",
      };
      sectionSummaryElement.height = 20; // Set a smaller height
    }
  }

  //Function to manger the each Section Heading Height..
  function managerHeadingHeight(workBook, sectionHeading, borderStyle) {
    const headerRow = workBook.addRow(sectionHeading);

    headerRow.height = 30; // Set the height for the header row

    headerRow.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: {
          argb: "FF112038",
        },
      };
      cell.font = {
        color: {
          argb: "FFFFFFFF",
        },
        bold: true,
      };
      cell.border = borderStyle;
      // Center align both horizontally and vertically
      cell.alignment = {
        horizontal: "center",
        vertical: "middle",
      };
    });
  }

  return (
    <>
      <div>
        <div className="p-2">
          <section id="productTable">
            <table class="w-full productTable">
              <thead>
                <tr>
                  <td
                    colSpan={15}
                    class="border border-slate-600 text-left ..."
                  >
                    <strong>Client ID: </strong>
                    <p id="c_id">{projectData ? projectData.client_id : ""}</p>
                  </td>
                </tr>
                <tr>
                  <td
                    colSpan={15}
                    class="border border-slate-600 text-left ..."
                  >
                    <strong>Client Name: </strong>
                    {""}
                    <p id="namec">
                      {projectData ? projectData.client.client_name : ""}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td
                    colSpan={15}
                    class="border border-slate-600 text-left ..."
                  >
                    {" "}
                    <strong>Site Address: </strong>
                    <p id="c_site">
                      {projectData ? projectData.client.site_add : ""}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td
                    colSpan={15}
                    class="border border-slate-600 text-left ..."
                  >
                    <strong>Architect Firm Detail: </strong>{" "}
                    <p id="c_afd">
                      {projectData ? projectData.client.afd : ""}{" "}
                    </p>
                  </td>
                </tr>
                {/* email */}
                <tr>
                  <td
                    colSpan={15}
                    class="border border-slate-600 text-left ..."
                  >
                    <strong>Email: </strong>{" "}
                    <p id="c_email">
                      {projectData ? projectData.client.email : ""}{" "}
                    </p>
                  </td>
                </tr>
                {/* phone */}
                <tr>
                  <td
                    colSpan={15}
                    class="border border-slate-600 text-left ..."
                  >
                    <strong>Phone: </strong>{" "}
                    <p id="c_phone">
                      {projectData ? projectData.client.phone : ""}{" "}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td
                    colSpan={15}
                    class="border border-slate-600 text-left ..."
                  >
                    <strong>Addressed To: </strong>
                    <p id="c_add_to">
                      {projectData ? projectData.client.add_to : ""}{" "}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td
                    colSpan={15}
                    class="border border-slate-600 text-left ..."
                  >
                    <strong>Project ID: </strong>
                    <p id="c_project_id">
                      {" "}
                      {projectData ? projectData.project_id : ""}{" "}
                    </p>
                  </td>
                  <hr></hr>
                </tr>
                <tr>
                  <td
                    colSpan={15}
                    class="border border-slate-600 text-left ..."
                  >
                    <strong>Date: </strong>
                    <p id="c_date">
                      {projectData
                        ? new Date(projectData.created_at).toLocaleDateString()
                        : ""}{" "}
                    </p>
                  </td>
                  <hr></hr>
                </tr>
                <tr>
                  <td
                    colSpan={15}
                    class="border border-slate-600 text-left ..."
                  >
                    <strong>Date: </strong>
                    <p id="valid_date">
                      {projectData
                        ? new Date(projectData.valid_date).toLocaleDateString()
                        : ""}{" "}
                    </p>
                  </td>
                  <hr></hr>
                </tr>
              </thead>
            </table>

            <table class="w-full border-collapse border border-slate-500 ... productTable">
              <thead>
                <tr className="bg-blue-950 text-white client_details">
                  <th class=" text-center border border-slate-600 text-left ...">
                    Serial No
                  </th>
                  <th class="text-center border border-slate-600 text-left ...">
                    Area
                  </th>
                  <th class=" text-center border border-slate-600 text-left ...">
                    SKU Code
                  </th>
                  <th class="text-center border border-slate-600 text-left ...">
                    Brand
                  </th>
                  <th class="text-center border border-slate-600 text-left w-24 ">
                    Brand Description{" "}
                  </th>
                  <th class="text-center border border-slate-600 text-left ...">
                    Finish
                  </th>

                  <th class="text-center border border-slate-600 text-left ...">
                    Collection
                  </th>
                  <th class="text-center border border-slate-600 text-left ...">
                    Product Typ Group
                  </th>
                  <th class="text-center border border-slate-600 text-left ...">
                    HSN Code
                  </th>
                  <th class="text-center border border-slate-600 text-left ...">
                    Category
                  </th>
                  <th class="text-center border border-slate-600 text-left ...">
                    Price Segment
                  </th>
                  <th class="text-center border border-slate-600 text-left ...">
                    Preferences
                  </th>
                  <th class="text-center border border-slate-600 text-left ...">
                    Product Image
                  </th>
                  <th class="text-center border border-slate-600 text-left ...">
                    Line Diagram
                  </th>
                  <th class="text-center border border-slate-600 text-left ...">
                    Quantity
                  </th>
                  <th class="text-center border border-slate-600 text-left ...">
                    MRP ({getCurrencySymbol()})
                  </th>
                  <th class="text-center border border-slate-600 text-left ...">
                    Base Price ({getCurrencySymbol()})
                  </th>
                  <th class="text-center border border-slate-600 text-left ...">
                    Discount %
                  </th>
                  <th class="text-center border border-slate-600 text-left w-24 ">
                    Discount Price ({getCurrencySymbol()})
                  </th>
                  <th class="text-center border border-slate-600 text-left w-24 ">
                    Offer Price / Unit ({getCurrencySymbol()})
                  </th>
                  <th class="text-center border border-slate-600 text-left ...">
                    GST
                  </th>
                  <th class="text-center border border-slate-600 text-left ...">
                    Total Discount ({getCurrencySymbol()})
                  </th>
                  <th class="text-center border border-slate-600 text-left ...">
                    Total ({getCurrencySymbol()})
                  </th>
                </tr>
              </thead>
              <tbody>
                {<div class="excel_loder">{loading && <Loader />}</div>}
                {sectionTotal > 0
                  ? sectionArr.map(([sectionName, data], index) => {
                    let sectionTotalMRP = 0;

                    return (
                      <>
                        {data
                          .map((item, itemindex) => {
                            // sectionTotalMRP +=
                            //   item.product_view_attr.mrp * item.qty;

                            // const isGstZero = item.gst == 0 || item.gst == 0.00 || !item.gst;

                            // const offerUnit = isGstZero
                            //   ? Number(item.unit || 0) - Number(item.disc_price || 0)
                            //   : Number(item.product_view_attr?.mrp || 0) - Number(item.disc_price || 0);

                            const basePrice = Number(item.unit || 0);
                            const gst = Number(item.gst || 0);
                            const qty = Number(item.qty || 0);
                            const discount = Number(item.disc_price || 0);

                            // Calculate MRP including GST
                            const mrp = basePrice + (basePrice * gst) / 100;

                            // Calculate section MRP
                            sectionTotalMRP += mrp * qty;

                            // Calculate offer price per unit
                            const offerUnit = mrp - discount;

                            return data.length === 1 ? (
                              <>
                                <tr className="section-heading">
                                  <td
                                    colSpan="12"
                                    className="border p-2 text-center"
                                  >
                                    {item.section_name}
                                  </td>
                                </tr>
                                <tr className="s1">
                                  <td className="border p-2 text-center">
                                    {itemindex + 1}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {item.sku_code}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {
                                      item.area === 'Shower' ? 'SHOWER' :
                                        item.area === 'Basin' ? 'BASIN' :
                                          item.area === 'EWC' ? 'EWC' :
                                            item.area === 'Kitchen' ? 'KITCHEN' :
                                              item.area === 'Faucet' ? 'FAUCET' :
                                                ''
                                    }
                                  </td>
                                  <td className="border p-2 text-center">
                                    {item.product_view_attr.brand}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {item.product_view_attr.product_desc}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {item.product_view_attr.finish}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {item.product_view_attr.collection}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {item.product_view_attr.product_typ_group}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {item.product_view_attr.hsnCode}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {item.product_view_attr.category}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {item.product_view_attr.priceSegment}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {item.product_view_attr.preferences}
                                  </td>
                                  <td className="border p-2 text-center w-24">
                                    <img
                                      src={item.product_view_attr.image}
                                      className="w-24"
                                    />
                                  </td>
                                  <td className="border p-2 text-center w-24">
                                    <img
                                      src={item.product_view_attr.linediagram_image}
                                      className="w-24"
                                    />
                                  </td>
                                  <td className="border p-2 text-center">
                                    {item.qty}
                                  </td>

                                  <td className="border p-2 text-center">
                                    {formatAmount(mrp)}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {formatAmount(item.unit)}
                                  </td>
                                  <td className="border p-2 text-center w-24">
                                    {formatNumber(item.disc_per)}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {formatAmount(item.disc_price)}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {formatAmount(offerUnit)}
                                  </td>
                                  <td className="border p-2 text-center w-24">
                                    {item.gst ? item.gst : 0}
                                  </td>
                                  <td className="border px-3 py-2 text-center">
                                    {formatAmount(parseFloat(item.disc_price) * parseFloat(item.qty))}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {formatAmount(item.total)}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    colSpan="12"
                                    className="border p-2  relative float-right"
                                  >
                                    List Price :
                                    {formatAmount(mrp * item.qty)}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    colSpan="12"
                                    className="border p-2 text-center text-right"
                                  >
                                    Offer Price : {formatAmount(item.total)}{" "}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    colSpan="12"
                                    className="border p-2 text-center text-right"
                                  >
                                    Shower Area Subtotal:{" "}
                                    {formatAmount(item.shower_area)}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    colSpan="12"
                                    className="border p-2 text-center text-right"
                                  >
                                    Basin Area Subtotal:{" "}
                                    {formatAmount(item.Basin)}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    colSpan="12"
                                    className="border p-2 text-center text-right"
                                  >
                                    EWC Area Subtotal:{" "}
                                    {formatAmount(item.Ewc)}{" "}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    colSpan="12"
                                    className="border p-2 text-center text-right"
                                  >
                                    Kitchen Area Subtotal:{" "}
                                    {formatAmount(item.kitchen)}{" "}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    colSpan="12"
                                    className="border p-2 text-center text-right"
                                  >
                                    Faucet Area Subtotal:{" "}
                                    {formatAmount(item.faucets)}{" "}
                                  </td>
                                </tr>

                                <tr>
                                  <td
                                    colSpan="12"
                                    className="border p-2 text-center text-right"
                                  >
                                    Total Quantity:{" "}
                                    {formatNumber(item.quantity)}{" "}
                                  </td>
                                </tr>
                              </>
                            ) : itemindex === 0 ? (
                              <>
                                <tr className="section-heading">
                                  <td
                                    colSpan="12"
                                    className="border p-2 text-center"
                                  >
                                    {item.section_name}
                                  </td>
                                </tr>
                                <tr className="s1">
                                  <td className="border p-2 text-center">
                                    {itemindex + 1}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {item.sku_code}
                                  </td>
                                  <td className="border p-2 text-center">
                                    <td className="border p-2 text-center">
                                      {
                                        item.area === 'Shower' ? 'SHOWER' :
                                          item.area === 'Basin' ? 'BASIN' :
                                            item.area === 'EWC' ? 'EWC' :
                                              item.area === 'Kitchen' ? 'KITCHEN' :
                                                item.area === 'Faucet' ? 'FAUCET' :
                                                  ''
                                      }
                                    </td>
                                  </td>
                                  <td className="border p-2 text-center">
                                    {item.product_view_attr.brand}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {item.product_view_attr.product_desc}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {item.product_view_attr.finish}
                                  </td>

                                  <td className="border p-2 text-center">
                                    {item.product_view_attr.collection}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {item.product_view_attr.product_typ_group}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {item.product_view_attr.hsnCode}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {item.product_view_attr.category}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {item.product_view_attr.priceSegment}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {item.product_view_attr.preferences}
                                  </td>
                                  <td
                                    className="border p-2 text-center w-24"
                                    style={myStyles}
                                  >
                                    <img
                                      src={item.product_view_attr.image}
                                      className="w-24"
                                    />
                                  </td>
                                  <td
                                    className="border p-2 text-center w-24"
                                    style={myStyles}
                                  >
                                    <img
                                      src={item.product_view_attr.linediagram_image}
                                      className="w-24"
                                    />
                                  </td>
                                  <td className="border p-2 text-center">
                                    {item.qty}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {formatAmount(mrp)}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {formatAmount(item.unit)}
                                  </td>
                                  <td className="border p-2 text-center w-24">
                                    {formatNumber(item.disc_per)}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {formatAmount(item.disc_price)}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {formatAmount(offerUnit)}
                                  </td>
                                  <td className="border p-2 text-center w-24">
                                    {item.gst ? formatNoDecimal(item.gst) : 0}
                                  </td>
                                  <td className="border px-3 py-2 text-center">
                                    {formatAmount(parseFloat(item.disc_price) * parseFloat(item.qty))}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {formatAmount(item.total)}
                                  </td>
                                </tr>
                              </>
                            ) : itemindex + 1 === data.length ? (
                              <>
                                <tr className="s1">
                                  <td className="border p-2 text-center">
                                    {itemindex + 1}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {item.sku_code}
                                  </td>
                                  <td className="border p-2 text-center">
                                    <td className="border p-2 text-center">
                                      {
                                        item.area === 'Shower' ? 'SHOWER' :
                                          item.area === 'Basin' ? 'BASIN' :
                                            item.area === 'EWC' ? 'EWC' :
                                              item.area === 'Kitchen' ? 'KITCHEN' :
                                                item.area === 'Faucet' ? 'FAUCET' :
                                                  ''
                                      }
                                    </td>
                                  </td>
                                  <td className="border p-2 text-center">
                                    {item.product_view_attr.brand}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {item.product_view_attr.product_desc}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {item.product_view_attr.finish}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {item.product_view_attr.collection}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {item.product_view_attr.product_typ_group}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {item.product_view_attr.hsnCode}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {item.product_view_attr.category}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {item.product_view_attr.priceSegment}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {item.product_view_attr.preferences}
                                  </td>
                                  <td
                                    className="border p-2 text-center w-24"
                                    style={myStyles}
                                  >
                                    <img
                                      src={item.product_view_attr.image}
                                      className="w-24"
                                    />
                                  </td>
                                  <td
                                    className="border p-2 text-center w-24"
                                    style={myStyles}
                                  >
                                    <img
                                      src={item.product_view_attr.linediagram_image}
                                      className="w-24"
                                    />
                                  </td>
                                  <td className="border p-2 text-center">
                                    {item.qty}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {formatAmount(mrp)}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {formatAmount(item.unit)}
                                  </td>
                                  <td className="border p-2 text-center w-24">
                                    {formatNumber(item.disc_per)}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {formatAmount(item.disc_price)}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {formatAmount(offerUnit)}
                                  </td>
                                  <td className="border p-2 text-center w-24">
                                    {item.gst ? item.gst : 0}
                                  </td>
                                  <td className="border px-3 py-2 text-center">
                                    {formatAmount(parseFloat(item.disc_price) * parseFloat(item.qty))}
                                  </td>
                                  <td className="border p-2 text-center">
                                    {formatAmount(item.total)}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    colSpan="12"
                                    className="border p-2 text-center text-right"
                                  >
                                    List Price :
                                    {formatAmount(sectionTotalMRP)}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    colSpan="12"
                                    className="border p-2 text-center text-right"
                                  >
                                    Offer Price : {formatAmount(item.totals)}{" "}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    colSpan="12"
                                    className="border p-2 text-center text-right"
                                  >
                                    Shower Area Offer Price:
                                    {formatAmount(item.shower_area)}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    colSpan="12"
                                    className="border p-2 text-center text-right"
                                  >
                                    Basin Area Offer Price:{" "}
                                    {formatAmount(item.Basin)}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    colSpan="12"
                                    className="border p-2 text-center text-right"
                                  >
                                    EWC Area Offer Price:{" "}
                                    {formatAmount(item.Ewc)}{" "}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    colSpan="12"
                                    className="border p-2 text-center text-right"
                                  >
                                    Kitchen Area Offer Price:{" "}
                                    {formatAmount(item.kitchen)}{" "}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    colSpan="12"
                                    className="border p-2 text-center text-right"
                                  >
                                    Faucet Area Offer Price:{" "}
                                    {formatAmount(item.faucets)}{" "}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    colSpan="12"
                                    className="border p-2 text-center text-right"
                                  >
                                    Total Quantity:{" "}
                                    {formatNumber(item.quantity)}{" "}
                                  </td>
                                </tr>
                              </>
                            ) : (
                              <tr>
                                <td className="border p-2 text-center">
                                  {itemindex + 1}
                                </td>
                                <td className="border p-2 text-center">
                                  {item.sku_code}
                                </td>
                                <td className="border p-2 text-center">
                                  <td className="border p-2 text-center">
                                    {
                                      item.area === 'Shower' ? 'SHOWER' :
                                        item.area === 'Basin' ? 'BASIN' :
                                          item.area === 'EWC' ? 'EWC' :
                                            item.area === 'Kitchen' ? 'KITCHEN' :
                                              item.area === 'Faucet' ? 'FAUCET' :
                                                ''
                                    }
                                  </td>
                                </td>
                                <td className="border p-2 text-center">
                                  {item.product_view_attr.brand}
                                </td>
                                <td className="border p-2 text-center">
                                  {item.product_view_attr.product_desc}
                                </td>
                                <td className="border p-2 text-center">
                                  {item.product_view_attr.finish}
                                </td>
                                <td className="border p-2 text-center">
                                  {item.product_view_attr.collection}
                                </td>
                                <td className="border p-2 text-center">
                                  {item.product_view_attr.product_typ_group}
                                </td>
                                <td className="border p-2 text-center">
                                  {item.product_view_attr.hsnCode}
                                </td>
                                <td className="border p-2 text-center">
                                  {item.product_view_attr.category}
                                </td>
                                <td className="border p-2 text-center">
                                  {item.product_view_attr.priceSegment}
                                </td>
                                <td className="border p-2 text-center">
                                  {item.product_view_attr.preferences}
                                </td>
                                <td
                                  className="border p-2 text-center w-24"
                                  style={myStyles}
                                >
                                  <img
                                    src={item.product_view_attr.image}
                                    className="w-24"
                                  />
                                </td>
                                <td
                                  className="border p-2 text-center w-24"
                                  style={myStyles}
                                >
                                  <img
                                    src={item.product_view_attr.linediagram_image}
                                    className="w-24"
                                  />
                                </td>
                                <td className="border p-2 text-center">
                                  {item.qty}
                                </td>
                                <td className="border p-2 text-center">
                                  {formatAmount(mrp)}
                                </td>
                                <td className="border p-2 text-center">
                                  {formatAmount(item.unit)}
                                </td>
                                <td className="border p-2 text-center w-24">
                                  {formatNumber(item.disc_per)}
                                </td>
                                <td className="border p-2 text-center">
                                  {formatAmount(item.disc_price)}
                                </td>
                                <td className="border p-2 text-center">
                                  {formatAmount(offerUnit)}
                                </td>
                                <td className="border p-2 text-center w-24">
                                  {item.gst ? formatNoDecimal(item.gst) : 0}
                                </td>
                                <td className="border px-3 py-2 text-center">
                                  {formatAmount(parseFloat(item.disc_price) * parseFloat(item.qty))}
                                </td>
                                <td className="border p-2 text-center">
                                  {formatAmount(item.total)}
                                </td>
                              </tr>
                            );
                          })}
                      </>
                    );
                  })
                  : "No Data found"}
              </tbody>
            </table>
            <button
              onClick={downloadExcelFile}
              type="button"
              className="bg-blue-950 text-white p-4 rounded justify-self-center mt-2"
              disabled={disable}
            >
              {button}
            </button>
          </section>
        </div>
      </div>
    </>
  );
};

export default DownloadSummary;